module.exports = __webpack_public_path__ + "static/media/Network.c8aabce0.png";